import { makeStyles } from "@material-ui/core";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Backdrop,
  Button,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
  styled,
} from "@mui/material";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import useDownloader from "react-use-downloader";
import ConfirmationCard from "../../components/verification/confirmationCard";
import { GetInstallmentTableRequest } from "../../models/loan.model";
import { CheckPoliceLetterFile } from "../../services/vehicle.service";

export default function FacilityFileDetail(props: any) {
  const history = useHistory<{
    id: any;
    // from?: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [showInstallmentComponent, setShowInstallmentComponent] = useState(
    false
  );
  const [installmentsTable, setInstallmentsTable] = useState(false);

  const request = new GetInstallmentTableRequest();
  // const [dataGetInstallmentTable, setDataGetInstallmentTable] = useState<
  //   GetInstallmentTableResponse
  // >();
  const {
    size,
    elapsed,
    percentage,
    download,
    cancel,
    error,
    isInProgress,
  } = useDownloader();
  const handleClick = () => {
    props.showInstallmentComponent(true);
    props.setFlagActionTab(true);
    setShowInstallmentComponent(true);
    props.isCore
      ? (request.coreReferenceKey = props.requestDetail?.referenceKey)
      : (request.appReferenceKey = props.requestDetail?.referenceKey);
    request.loanRequestId = props.requestDetail?.loanRequestId;
    // getInstallmentTableMutation(request);
  };
  useEffect(() => {
    // props.isCore
    //   ? (request.coreReferenceKey = props.requestDetail?.referenceKey)
    //   : (request.appReferenceKey = props.requestDetail?.referenceKey);
    // request.loanRequestId = props.requestDetail?.loanRequestId;
    // getInstallmentTableMutation(request);
  }, []);
  const policeHandleClick = () => {
    DownloadPoliceLetterMutation(props.requestDetail.referenceKey);
  };
  const filename = "نامه راهور.pdf";
  const {
    mutate: DownloadPoliceLetterMutation,
    isLoading: isLoad,
  } = useMutation(CheckPoliceLetterFile, {
    onSuccess: (data) => {
      if (!data.isSuccess) {
      } else {
        download(data.data?.downloadUrl!, filename);
      }
    },
    onError: (e) => {},
  });

  const handleBackClick = () => {
    props.showInstallmentComponent(false);
    props.setFlagActionTab(false);
    setShowInstallmentComponent(false);
  };

  const useStyles = makeStyles((theme) => ({
    collapse: {
      display: "inherit",
      "&:hover": {
        backgroundColor: "transparent", // remove hover color
      },
      "&.MuiCollapse-entered": {
        backgroundColor: "transparent", // remove click color
      },
    },
  }));

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  // collapse

  interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
  }
  const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));
  const loanList = {
    title: props.requestDetail?.supplierName,
    financialSupplierTitle: props.requestDetail?.financialSupplierTitle,
    finalLoanAmount: props.requestDetail?.loanAmount,
    finalInstallmentCount: props.requestDetail?.installmentCount,
    profitPercentage: props.requestDetail?.profitRate,
    expirationDate_Persian: props.requestDetail?.settlementDatePersian,
    customerFullName: props.requestDetail?.customerFullName,
    customerNationalCode: props.requestDetail?.customerNationalCode,
    birthDatePersian: props.requestDetail?.birthDatePersian,
    customerMobileNumber: props.requestDetail?.customerMobileNumber,
    customerPostalCode: props.requestDetail?.customerPostalCode,
    customerAddress: props.requestDetail?.customerAddress,
    supplierSettlementStatusTitle:
      props.requestDetail?.supplierSettlementStatusTitle,
    loanRequestStatusTitle: props.requestDetail?.loanRequestStatusTitle,
    loanTemplateTitle: props.requestDetail?.loanTemplateTitle,
    englishFirstName: props.requestDetail?.englishFirstName,
    englishLastName: props.requestDetail?.englishLastName,
    digitallSignRequired: props.requestDetail?.digitallSignRequired,
    installmentAmount: props.requestDetail?.installmentAmount,
    stepSpace: props.requestDetail?.stepSpace,
    installmentDuration: props.requestDetail?.installmentDuration,
    organizationTitle: props.requestDetail?.organizationTitle,
  };
  const classes = useStyles();

  // const { mutateAsync: getInstallmentTableMutation } = useMutation(
  //   getInstallmentTable,
  //   {
  //     onSuccess: (data: ApiResultModel<GetInstallmentTableResponse[]>) => {
  //       if (data.isSuccess) {
  //         props.setDataGetInstallmentTable(data.data);
  //         if (data.data.length > 0) {
  //           setInstallmentsTable(true);
  //         }
  //       }
  //     },
  //   }
  // );
  return (
    <Card
      style={{
        margin: "1.9vh",
        boxShadow:
          "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2) !important",
        backgroundColor: "#F9F6F7",
      }}
    >
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>
            <div>
              <ConfirmationCard
                value={loanList}
                sendFrom={"facility"}
                buttonChild={props.buttonChild}
              />
            </div>
          </Typography>
        </CardContent>
      </Collapse>
      {!expanded ? (
        <CardContent style={{ paddingBottom: "0" }}>
          <Typography paragraph>
            <div style={{ marginBottom: "-18px" }}>
              <Grid
                container
                xs={12}
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ backgroundColor: "#F9F6F7" }}
              >
                <Grid
                  item
                  xs={8}
                  md={8}
                  sm={12}
                  style={{
                    backgroundColor: "#F6F8F9",
                    textAlign: "right",
                    margin: "1vh",
                  }}
                  className="confirmFacility"
                >
                  {props.child}
                </Grid>
                {!showInstallmentComponent ? (
                  <>
                    {/* <Grid item xs={1} style={{ minWidth: "15%" }}></Grid> */}
                    {props.requestDetail.loanTemplateType == "Vehicle" ? (
                      <>
                        <Grid
                          item
                          xs={2}
                          md={2}
                          sm={4}
                          style={{ marginTop: "2vh", textAlign: "end" }}
                        >
                          <Button
                            className="installmentTitle"
                            onClick={policeHandleClick}
                            style={{
                              whiteSpace: "nowrap",
                              marginRight: "-1vh",
                            }}
                          >
                            <DownloadIcon style={{ marginLeft: "2px" }} />
                            دانلود نامه راهور
                            <span>
                              {" "}
                              {isInProgress ? (
                                <>
                                  <Backdrop
                                    hidden={false}
                                    open={true}
                                    sx={{ color: "#fff", zIndex: () => 1 }}
                                  >
                                    <CircularProgress color="inherit" />
                                  </Backdrop>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          </Button>
                        </Grid>
                        {props.installmentsTable ? (
                          <Grid
                            item
                            xs={1}
                            style={{
                              marginTop: "3vh",
                              maxWidth: "fit-content",
                            }}
                          >
                            <span style={{ color: "#CFD8DC" }}>|</span>
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <Grid
                        item
                        xs={2}
                        style={{ marginTop: "2vh", textAlign: "end" }}
                      ></Grid>
                    )}
                    {/* <Grid item xs={1} style={{ marginTop: "2vh" }}>
                      <Button
                        disabled={!props.installmentsTable}
                        className={props.installmentsTable ? "installmentTitle" : "disableColor"}
                        onClick={handleClick}
                        style={{ whiteSpace: "nowrap", marginRight: "-1vh" }}
                      >
                        <DateRangeIcon style={{ marginLeft: "2px" }} />
                        جدول اقساط
                      </Button>
                    </Grid> */}
                    {/* <Grid
                      item
                      xs={1}
                      style={{ marginTop: "1vh", textAlign: "end" }}
                    >
                      <Button
                        className="SuccessDefaultFont textFont14"
                        onClick={handleClick}
                      >
                        <DateRangeIcon style={{ marginLeft: "2px" }} />
                        جدول اقساط
                      </Button>
                    </Grid> */}
                    {/* <span style={{ margin: '2vh', color: '#CFD8DC' }}>|</span>
                    <Grid item xs={1} style={{ marginTop: '1vh' }}>
                      <Button className="colorTitle textFont14" style={{ whiteSpace: 'nowrap' }}><ManageSearchIcon style={{ marginLeft: '3px' }} />نتیجه استعلامات</Button>
                    </Grid> */}
                  </>
                ) : (
                  <>
                    <Grid item xs={1} style={{ minWidth: "15%" }}></Grid>
                    <Grid item xs={1} style={{ marginTop: "1vh" }}>
                      <Button
                        className="installmentTitle"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={handleBackClick}
                      >
                        بازگشت
                        <ArrowBackIosIcon />
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
          </Typography>
        </CardContent>
      ) : (
        ""
      )}
      <CardActions disableSpacing className={classes.collapse}>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          style={{ padding: "0px", width: "100%" }}
          className="collapsColor"
          // , width: "100%", backgroundColor: "#F6F8F9"
          // className="test12"
        >
          {!expanded ? (
            <>
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#EDF2F6",
                  marginLeft: "-1vh",
                  marginRight: "-1vh",
                  marginBottom: "-1vh",
                }}
              >
                <ArrowDropDownIcon
                  style={{
                    height: "24px",
                    width: "24px",
                    marginTop: "0.1vh",
                    color: "#9AAFC4",
                  }}
                />
              </Grid>
            </>
          ) : (
            <div
              style={{
                color: "#1D4A87",
                backgroundColor: "#EDF2F6",
                marginLeft: "-1vh",
                marginRight: "-1vh",
                marginTop: "-1vh",
              }}
            >
              <ArrowDropDownIcon
                style={{ height: "24px", width: "24px", color: "#9AAFC4" }}
              />
            </div>
          )}
        </ExpandMore>
      </CardActions>
    </Card>
  );
}
